import { PaperContainer } from '@ui-components/containers/PaperContainer'
import { PropsWithChildren, ReactNode } from 'react'
import { styled } from 'styled-components'

import { Footer } from './Footer'

const BottomPadding = styled.div`
  padding-bottom: 64px;
`

interface WideContainerProps extends PropsWithChildren {
  footerContent?: ReactNode
  fullWidthFooter?: boolean
  ['data-testid']?: string
}

export const WideContainer = (props: WideContainerProps) => {
  const { footerContent, children, fullWidthFooter } = props
  return (
    <BottomPadding>
      <PaperContainer data-testid={props['data-testid'] ?? 'entrance'} $fullWidthSupport={true}>
        {children}
      </PaperContainer>
      <Footer fullWidthFooter={fullWidthFooter}>{footerContent}</Footer>
    </BottomPadding>
  )
}
